<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header" v-if="refundSearch">
        <h5 class="color_dark_red">Поиск завки для возврата</h5>
      </div>
      <div class="card-body">
        <form action="" @submit.prevent="searchOrders">
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="">Текст для поиска</label>
                <input type="text" @keyup="updateSearchOptions" @change="updateSearchOptions"
                       v-model="search.searchData" placeholder="Номер заявки, препарат..." class="form-control">
              </div>
            </div>
            <div class="col-md-4">
              <div v-if="cities.length" class="form-group cities_select">
                <label for="">Выберите город</label>
                <!--                <multiselect-->
                <!--                  name="user_role"-->
                <!--                  v-model="search.cities"-->
                <!--                  :options="cities"-->
                <!--                  placeholder="Все города"-->
                <!--                  track-by="title"-->
                <!--                  label="title"-->
                <!--                  :showLabels="false"-->
                <!--                  :searchable="false"-->
                <!--                  :multiple="true">-->
                <!--                </multiselect>-->
                <SelectCity
                  :updateSelectedCity="(cities) => search.cities = cities"
                />
              </div>
              <div v-if="cities.length" class="form-group cities_select">
                <select v-model="search.division" class="form-control">
                  <option :value="0">Любой дивизион</option>
                  <option v-for="d in sortArray($AllDivisions, 'title')" :value="d.id" v-if="d.is_active">{{
                      d.title
                    }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-4">

              <div class="form-group date_range">
                <label for="">Период поиска</label>
                <div class="input-group">
                  <datetime
                    input-class="form-control"
                    type="date"
                    :minute-step="60"
                    format="dd.MM.yyyy"
                    :auto="true"
                    v-model="search.range.start"></datetime>
                  <div class="input-group-prepend input-group-append">
                    <span class="input-group-text">по</span>
                  </div>
                  <datetime
                    input-class="form-control"
                    type="date"
                    :minute-step="60"
                    format="dd.MM.yyyy"
                    :auto="true"
                    v-model="search.range.end"></datetime>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group search_types">
                <div v-for="(opt, index) in searchOptionsFiltered">
                  <input type="radio" v-model="search.searchType" :id="`inlineRadio${index}`" :value="opt.value">
                  <label class="form-check-label" :for="`inlineRadio${index}`">{{ opt.title }}</label>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <CustomMultiSelect
                ref="selectedStatuses"
                :records="orderStatuses"
                :options="{placeholder:'Выберите статус заявки'}"
              />
              <div v-if="search.showCardPrePaid" class="mt-2">
                <multiselect
                  v-model="search.selectedCreditCards"
                  :options="getCreditCards()"
                  track-by="title"
                  label="title"
                  :show-labels="false"
                  placeholder="Выберите карту"
                  :multiple="true">
                </multiselect>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-check m-r-20 text-left" v-if="!refundSearch">
                <div v-bind:class="{'opacity': search.closedOnly}">
                  <div>
                    <input class="form-check-input" v-model="search.showCardPrePaid" type="checkbox" id="gridCheck11">
                    <label class="form-check-label" for="gridCheck11">
                      Заявки с предоплатой
                    </label>
                  </div>
                  <div>
                    <input class="form-check-input" v-model="search.showRejected" type="checkbox" id="gridCheck1">
                    <label class="form-check-label" for="gridCheck1">
                      Показывать также отмененные заявки
                    </label>
                  </div>
                  <div>
                    <input class="form-check-input" v-model="search.showClosed" type="checkbox" id="gridCheck2">
                    <label class="form-check-label" for="gridCheck2">
                      Показывать также выполненные
                    </label>
                  </div>
                  <div>
                    <input class="form-check-input" v-model="search.myProjects" type="checkbox" id="gridCheck3">
                    <label class="form-check-label" for="gridCheck3">
                      Искать только по моим проектам
                    </label>
                  </div>
                </div>
                <div>
                  <input class="form-check-input" v-model="search.closedOnly" type="checkbox" id="gridCheck4">
                  <label class="form-check-label" for="gridCheck4">
                    Искать только закрытые заявки
                  </label>
                </div>
                <div v-if="search.closedOnly">
                  <div>
                    <input class="form-check-input" v-model="search.reportDate" type="checkbox" id="gridCheck5">
                    <label class="form-check-label" for="gridCheck5">
                      Поиск по дате закрытия заявки
                    </label>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="text-right">
            <vue-ladda type="submit" button-class="btn btn-success"
                       data-style="zoom-in"
                       :loading="btnLoading">Поиск
            </vue-ladda>
          </div>
        </form>
      </div>
    </div>

    <div class="alert alert-warning" v-if="showSearchResult && !orders && !searchLoading">
      <p>Заявок не найдено</p>
    </div>

    <div v-if="orders || searchLoading" class="card">
      <div class="card-body">
        <pulse-loader :loading="searchLoading" :color="loadingColor" class="text-center"/>
        <ordersList v-if="orders"
                    :orders="orders"
                    :projects="projects"
                    :cities="citiesMapped"
                    :subStatuses="subStatuses"
                    :displayType="refundSearch ? 'refund' : 'natural'"
                    :sitesToEdit="sitesToEdit"
                    :openModal="modalRefundOrder"/>

        <div class="text-right pagination_div">

          <paginate v-if="paginator"
                    v-model="currentPage"
                    :page-count="paginator.last_page"
                    :page-range="8"
                    :margin-pages="2"
                    :click-handler="searchOrders"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>

        </div>
      </div>
    </div>

    <div v-if="orders" class="card">
      <div class="card-body">
        <div class="alert alert-info order_legend">
          <p>* В поле дата находится следующая информация (в зависимости от статуса):</p>
          <p>Введена вручную, обработана менеджером - указанная менеджером дата доставки (планированная)</p>
          <p>Доставлена, закрыта, Отказ у менеджера, отказ у курьера Отказ у менеджера, отказ у курьера - report date
            (дата получения финального статуса)</p>
        </div>
      </div>
    </div>

    <customModal v-if="modalData" v-show="modalData" :onModalClose="onModalClose" :onModalAccept="createRefundOrder"
                 :modalData="modalData"></customModal>

  </div>

</template>

<script>

import api from '@/api'
import Paginate from 'vuejs-paginate'
import Multiselect from 'vue-multiselect'
import {Datetime} from 'vue-datetime'
import moment from 'moment'
import VueLadda from 'vue-ladda/src/vue-ladda.vue'
import ordersList from '@/components/orders/ordersList'
import customModal from '@/components/modals/customModal'
import Paginator from '@/components/paginator'
import SelectCity from '@/components/cities/SelectCity'
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";

export default {
  components: {
    SelectCity,
    Multiselect,
    Datetime,
    ordersList,
    VueLadda,
    Paginator,
    customModal,
    Paginate,
    CustomMultiSelect,
  },
  data() {
    return {
      showSearchResult: false,
      sitesToEdit: {},
      modalData: null,
      refundSearch: false,
      subStatuses: null,
      currentPage: 1,
      paginator: null,
      btnLoading: false,
      searchLoading: false,
      loadingColor: this.$constants.LOADING_COLOR,
      orders: null,
      citiesMapped: [],
      cities: [],
      projects: [],
      creditCardsForSelect: [],
      search: {
        division: 0,
        selectedCreditCards: [],
        showCardPrePaid: false,
        showRejected: true,
        showClosed: true,

        reportDate: false,
        closedOnly: false,

        close_dropdown: true,
        // showAll: true,
        searchData: null,
        searchType: 1,
        cities: null,
        range: {
          start: moment().subtract(6, 'month').toISOString(),
          end: null
        }
      },
      orderStatuses: [
        {selectTitle: 'поступила с сайта', status: 0},
        {selectTitle: 'ручная', status: 9999},
        {selectTitle: 'обработана', status: 1},
        {selectTitle: 'назначена', status: 2},
        {selectTitle: 'отмена у менеджера', status: -2},
        {selectTitle: 'отмена у курьера', status: -3},
        {selectTitle: 'спрос', status: 8},
      ],
      searchOptions: [
        {
          title: 'По номеру заявки',
          value: 1,
          group: [1, 2]
        },
        {
          title: 'По сумме заявки',
          value: 2,
          group: [1]
        },
        {
          title: 'По мориону препарата',
          value: 4,
          group: [1, 2]
        },
        {
          title: 'По номеру телефона',
          value: 3,
          group: [1, 2, 5]
        },
        {
          title: 'По email',
          value: 7,
          group: [4]
        },
        {
          title: 'По названию препарата',
          value: 8,
          group: [3, 4]
        },
        {
          title: 'По ФИО клиента',
          value: 5,
          group: [3, 4]
        },
        {
          title: 'По адресу',
          value: 6,
          group: [3]
        },
      ],
      searchOptionsFiltered: []
    }
  },
  computed: {
    $AllCreditCards() {
      return [];
      // return this.$store.getters['platform/creditCards'];
    },
  },
  watch: {
    $route(to, from) {
      // if (to.name == 'searchOrderRefund') this.refundSearch = true;
      this.checkTypeOfSearch()
    }
  },
  mounted() {
    this.checkTypeOfSearch()
    this.getDataForSearch()
    if (this.$route.query && this.$route.query.ordersId) {
      this.$route.params.ordersId = this.$route.query.ordersId.split(',');
    }
    if (this.$route.params && this.$route.params.ordersId) {
      this.searchOrders(null, true)
    }
  },
  methods: {
    getCreditCards() {
      const arr = (this.$AllCreditCards || []).reduce((acc, c) => {
        if (!acc[c.use_type_id]) acc[c.use_type_id] = [];
        acc[c.use_type_id].push({
          ...c,
          // title: c.number.substr(c.number.length - 8) + ' ' + (c.owner?.short_name || 'Имя не указано')
          title: '(' + c.id + ') ' + c.number + ' ' + (c.owner?.short_name || 'Имя не указано')
        });
        return acc;
      }, {});
      return Object.keys(arr).reduce((acc, group) => {
        let groupTitle = 'Доставочные';
        switch (+group) {
          case 3:
            groupTitle = 'Регионы';
            break;
          case 1:
            groupTitle = 'Почтовые';
            break;
        }
        acc.push({title: groupTitle, $isDisabled: true})
        acc = [...acc, ...arr[group]];
        return acc;
      }, []);
    },
    modalRefundOrder(order) {
      let body = '<p>Клиент: <strong>' + order.client_name || (order.client && order.client.name) + '</strong>'
      order.details.forEach((d) => {
        body += '<p>' + d.new_drug.title + ': <strong>' + d.qty + '</strong> * <strong>' + d.price + '</strong></p>'
      })
      this.modalData = {
        header: 'Заявка на возврат',
        body: body,
        acceptBtnText: 'Создать',
        cancelBtnText: 'Отмена',
        orderId: order.id,
      }
    },
    createRefundOrder() {
      this.mixinGoToRouter('editOrder', {refund: true, id: this.modalData.orderId})
    },
    onModalClose() {

      this.modalData = null
    },
    checkTypeOfSearch() {
      this.refundSearch = false
      if (this.$route.name == 'searchOrderRefund') this.refundSearch = true
    },
    async getDataForSearch() {
      let {data} = await api.index('/orders/getDataForSearch')
      this.projects = data.projects
      Object.keys(data.cities).forEach((k) => {
        this.cities.push({id: k, title: data.cities[k]})
        this.citiesMapped[k] = data.cities[k]
        this.subStatuses = data.subStatuses
        this.sitesToEdit = data.sites
      })
      this.cities.push({id: 0, title: 'Почта'})
    },
    async searchOrders(page = null, byParams = false) {
      if (typeof page === 'object') page = null
      console.log(page)
      this.searchLoading = true
      this.btnLoading = true
      this.paginator = null
      this.orders = null
      this.search.refundSearch = this.refundSearch

      if (this.search.searchType == 3) { //phone
        let clearedSearch = (this.search.searchData.match(/\d+/g)).join('')
        if (clearedSearch.length < 4) {
          toastr['warning']('Недостаточно данных для поиска')
          return
        }
      }

      if (byParams) {
        this.search.ordersId = this.$route.params.ordersId
      }
      const searchData = {...this.search};
      searchData.selectedCreditCards = (searchData.selectedCreditCards || []).map((c) => c.id);
      searchData.statuses = this.$refs.selectedStatuses?.selectedRecords.map((s) => s.status);
      this.showSearchResult = true
      let {data: r_data} = await api.post('/orders/getOrdersBySearchData?page=' + page, searchData)
      const {data, ...pagination} = r_data.orders
      this.paginator = pagination
      this.currentPage = this.paginator.current_page
      this.orders = data
      if (byParams) {
        delete this.search.ordersId
      }
      this.searchLoading = false
      this.btnLoading = false
    },
    updateSearchOptions(e) {
      this.search.searchType = 1
      this.searchOptionsFiltered = []
      let search = e.target.value
      if (!search) return

      if (search.match(/^[0-9 \-\+()]+$/)) {
        let clearedSearch = (search.match(/\d+/g)).join('')
        if (clearedSearch.length >= 2 && clearedSearch.substring(0, 2) == 79) {
          // this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(5) >= 0);
          this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(2) >= 0)
          this.search.searchType = 3
          return
        }
      }

      if (search.match(/^[0-9]+$/)) {
        if (search.length > 6) {
          this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(2) >= 0)
        } else {
          this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(1) >= 0)
        }
        this.search.searchType = this.searchOptionsFiltered[0].value
        return
      }

      if (search.match(/^[0-9 \-\+()]+$/)) {
        let clearedSearch = (search.match(/\d+/g)).join('')
        this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(5) >= 0)
        this.search.searchType = 3
        return
      }

      if (/[а-яА-ЯЁё]/.test(search)) {
        this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(3) >= 0)
        this.search.searchType = this.searchOptionsFiltered[0].value
        return
      }

      this.searchOptionsFiltered = this.searchOptions.filter((o) => o.group.indexOf(4) >= 0)
      this.search.searchType = this.searchOptionsFiltered[0].value

    }
  }
}

</script>

<style scoped>
.opacity {
  opacity: .3;
}
</style>

<style>
.order_legend p {
  margin-bottom: 5px;
}

.pagination_div .pagination {
  justify-content: flex-end;
}

.date_range .vdatetime {
  width: 125px;
}

.cities_select .multiselect__tags {
  padding: 5px 40px 0 8px;
  min-height: 37px;
}

.cities_select .multiselect__placeholder {
  margin-bottom: 8px;
}

</style>
